module.exports = __webpack_public_path__ + "static/media/nl.e2035a45.pdf";